module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-9-782ac74dd00c3a90f2fd1191c3f9ebd0.svg";